// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3sNDO","actions":"GroupTable_actions__1ZflA","deleteModalFooter":"GroupTable_deleteModalFooter__1W6kL"};